import ErpCrud from "@/components/ErpCrud";

export default function AdminAMC() {
  return (
    <ErpCrud
      testid="admin-amc"
      title="AMC Contracts"
      subtitle="Annual maintenance / service contracts — app ke saath synced"
      endpoint="/admin/amc_contracts"
      fields={[
        { key: "customer_name", label: "Customer", type: "text" },
        { key: "customer_phone", label: "Phone", type: "text" },
        { key: "asset", label: "Asset / Product", type: "text" },
        { key: "start_date", label: "Start Date", type: "date" },
        { key: "end_date", label: "End Date", type: "date" },
        { key: "amount", label: "Contract Amount ₹", type: "number" },
        { key: "visits_total", label: "Total Visits", type: "number" },
        { key: "visits_used", label: "Visits Used", type: "number" },
        { key: "status", label: "Status", type: "select", options: [
          { value: "active", label: "Active" }, { value: "expired", label: "Expired" }, { value: "cancelled", label: "Cancelled" },
        ] },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "customer_name", label: "Customer" },
        { key: "asset", label: "Asset" },
        { key: "start_date", label: "Start" },
        { key: "end_date", label: "End" },
        { key: "amount", label: "Amount" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
